export default __webpack_public_path__ + "static/media/mechanic-2.3fc6ed6c.jpg";